import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Flame, Trophy } from "lucide-react";
import { motion } from "framer-motion";

const MeditationStreakCard = ({ streakData }) => {
  if (!streakData) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.35 }}
    >
      <Card className="glass bg-gradient-to-br from-orange-500/10 to-amber-500/10 border-orange-500/20" data-testid="meditation-streak-card">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-semibold text-white flex items-center justify-between">
            <span className="flex items-center gap-2">
              <Flame className="w-5 h-5 text-orange-400" />
              Meditation Streak
            </span>
            <Link to="/achievements">
              <Button variant="ghost" size="sm" className="text-mystic-300 hover:text-white">
                Achievements <Trophy className="w-4 h-4 ml-1" />
              </Button>
            </Link>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="glass-light rounded-xl p-4 text-center">
              <div className="flex items-center justify-center gap-1 mb-1">
                <Flame className={`w-6 h-6 ${streakData.current_streak > 0 ? "text-orange-400" : "text-mystic-500"}`} />
                <span className="text-2xl font-bold text-white">{streakData.current_streak}</span>
              </div>
              <p className="text-xs text-mystic-300">Current Streak</p>
            </div>
            <div className="glass-light rounded-xl p-4 text-center">
              <div className="flex items-center justify-center gap-1 mb-1">
                <Trophy className="w-6 h-6 text-amber-400" />
                <span className="text-2xl font-bold text-white">{streakData.longest_streak}</span>
              </div>
              <p className="text-xs text-mystic-300">Longest Streak</p>
            </div>
            <div className="glass-light rounded-xl p-4 text-center">
              <div className="text-2xl font-bold text-white mb-1">{streakData.total_sessions}</div>
              <p className="text-xs text-mystic-300">Total Sessions</p>
            </div>
            <div className="glass-light rounded-xl p-4 text-center">
              <div className="text-2xl font-bold text-white mb-1">{streakData.total_minutes || 0}</div>
              <p className="text-xs text-mystic-300">Minutes Meditated</p>
            </div>
          </div>
          {!streakData.meditated_today && (
            <div className="mt-4 text-center">
              <p className="text-sm text-orange-300">
                {streakData.current_streak > 0
                  ? `Keep your ${streakData.current_streak}-day streak alive! Meditate today.`
                  : "Start your meditation journey today!"}
              </p>
            </div>
          )}
          {streakData.meditated_today && (
            <div className="mt-4 text-center">
              <span className="text-sm text-green-400 flex items-center justify-center gap-1">
                <span className="w-2 h-2 bg-green-400 rounded-full"></span>
                You've meditated today!
              </span>
            </div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default MeditationStreakCard;
